<template>
  <div class="animated fadeIn">
    <b-row class>
      <b-col>
        <h2>เข้าสู่ระบบ</h2>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col sm="6" md="4">
        <label for="email">อีเมล</label>
        <b-input-group>
          <b-form-input v-model="email" id="email"></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row class="mt-2">
      <b-col sm="6" md="4">
        <label for="password">รหัสผ่าน</label>
        <b-input-group>
          <b-form-input v-model="password" id="password" type="password"></b-form-input>
        </b-input-group>
      </b-col>
    </b-row>
    <b-row v-if="email && password" class="mt-3">
      <b-col sm="6" md="4">
        <b-button variant="primary" @click="login">เข้าสู่ระบบ</b-button>
      </b-col>
    </b-row>
    <b-row class="mt-3">
      <b-col sm="6" md="4">
        หรือสมัครสมาชิก
        <b-link :to="{name: 'สมัครสมาชิก'}">คลิกที่นี่</b-link>
        <br />หากลืมรหัสผ่าน
        <b-link :to="{name: 'ลืมรหัสผ่าน'}">คลิกที่นี่</b-link>
      </b-col>
    </b-row>
    <ModalLoading />
  </div>
</template>

<script>
import User from '../services/http/User'
import ModalLoading from '../components/ModalLoading'

export default {
  components: {
    ModalLoading
  },
  data () {
    return {
      email: null,
      password: null,
      prevRoute: null
    }
  },
  methods: {
    async login () {
      Window.Event.$emit('showModalLoading')

      var user = new User()
      var data = {
        email: this.email,
        password: this.password
      }
      try {
        var login = await user.emailLogin(data)
        if (login.code === 1) {
          await this.$bvModal.msgBoxOk('เข้าสู่ระบบแล้ว', this.$getConst('okModalClass'))
          this.$cookies.set('email', this.email)
          this.$cookies.set('token', login.token)
          this.$cookies.set('companyId', login.company._id)
          window.analytics.identify({ email: this.email })
          window.analytics.track('login', { email: this.email })
          Window.Event.$emit('checkLogin')
          // load user status
          await this.$store.dispatch('checkCompanyStatus')
          if (login.company.carrierStatus !== 1) {
            this.$router.push({ name: 'แก้ไขข้อมูลบริษัท' })
          } else {
            this.$router.go(-1)
          }
        } else {
          await this.$bvModal.msgBoxOk('รหัสผ่านหรืออีเมลไม่ถูกต้อง', this.$getConst('okModalClass'))
        }
      } catch (error) {
        await this.$bvModal.msgBoxOk('โปรดติดต่อผู้ดูแลระบบ', this.$getConst('okModalClass'))
        console.log(error)
      }

      Window.Event.$emit('closeModalLoading')
    }
  }
}
</script>
